import React from "react";
import Link from "../Link";
import "./ExpandRRSPButton.css";

const ExpandRRSPButton = () => {

    return (
        <Link href="/rrsp-page">
            <div className="rectangle-2 border-1px-athens-gray-2">
                <div className="expand-rrsp-button">
                    <div className="expand-rrsp-button-5">
                        <div className="rrsp-text">
                            <div className="rrsp-text-1 nunito-bold-blue-20px">RRSP</div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    )
}

export default ExpandRRSPButton;